module.exports = __webpack_public_path__ + "static/media/sonar.f11a11d.ogg";


//////////////////
// WEBPACK FOOTER
// ./static/audio/sonar.ogg
// module id = L4at
// module chunks = 1